import React from 'react';
import styled from 'styled-components';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';

const OrlResultSkeletonItem = () => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 390, h: 205 }
    : { w: 709, h: 73 };

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: height,
      }}
    >
      <PlaceholderLoader
        width={width}
        height={height}
        uid="orl-card-skeleton"
        style={{ height: '100%', width: '100%', display: 'block' }}
      >
        {mobile ? (
          <>
            <rect x="267" y="120" width="115" height="35" />
            <rect x="267" y="95" width="113" height="16" rx="6" />
            <rect x="10" y="178" width="164" height="16" rx="6" />
            <rect x="360" y="178" width="23" height="16" rx="6" />
            <rect x="8" y="9" width="264" height="16" rx="6" />
            <rect x="8" y="60" width="259" height="16" rx="6" />
            <rect x="8" y="80" width="166" height="16" rx="6" />
            <rect x="8" y="31" width="72" height="16" rx="6" />
            <rect x="8" y="123" width="72" height="16" rx="6" />
            <rect x="8" y="143" width="79" height="16" rx="6" />
            <rect width="390" height="1" />
            <rect y="166" width="390" height="1" />
            <rect y="204" width="390" height="1" />
          </>
        ) : (
          <>
            <rect x="127" y="5" width="111" height="16" rx="6" />
            <rect x="9" y="6" width="103" height="16" rx="6" />
            <rect x="9" y="27" width="103" height="16" rx="6" />
            <rect x="288" y="6" width="103" height="16" rx="6" />
            <rect x="434" y="7" width="103" height="16" rx="6" />
            <rect x="288" y="27" width="103" height="16" rx="6" />
            <rect x="288" y="48" width="103" height="16" rx="6" />
            <rect x="127" y="27" width="68" height="16" rx="6" />
            <rect x="127" y="50" width="143" height="16" rx="6" />
            <rect width="709" height="1" />
            <rect y="72" width="709" height="1" />
            <rect x="563" y="20" width="115" height="35" />
            <rect width="1" height="72" />
            <rect x="708" width="1" height="72" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
};

const ORLHeaderSkeleton: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { mobile } = useDeviceType();

  return (
    <div
      data-id="orl-header-skeleton"
      className={className}
      style={{
        padding: '15px 10px 20px',
      }}
    >
      <PlaceholderLoader
        uid={'SRLStatusSkeleton'}
        width={mobile ? 327 : 665}
        height={mobile ? 21 : 43}
        style={{
          width: '100%',
          height: mobile ? '21px' : '43px',
        }}
      >
        <>
          <rect width="55" height="23" rx="6" />
          <rect y="27" width="55" height="16" rx="6" />
          <rect x="118" y="27" width="111" height="16" rx="6" />
          <rect x="279" y="27" width="111" height="16" rx="6" />
          <rect x="554" y="27" width="111" height="16" rx="6" />
          <rect x="425" y="27" width="111" height="16" rx="6" />
          <rect x="118" width="98" height="23" rx="6" />
          <rect x="554" width="98" height="23" rx="6" />
          <rect x="425" width="72" height="23" rx="6" />
          <rect x="279" width="98" height="23" rx="6" />
        </>
      </PlaceholderLoader>
    </div>
  );
};

const OrlWrapper = styled.div(
  sx2CssThemeFn({
    mt: [4, 0],
  })
);

const OrlResultsSkeleton: React.FC = () => {
  const { mobile } = useDeviceType();

  const counts = 10;
  return (
    <OrlWrapper>
      {!mobile ? <ORLHeaderSkeleton /> : null}
      {Array.from({ length: counts }, (_, i) => (
        <OrlResultSkeletonItem key={i} />
      ))}
    </OrlWrapper>
  );
};

export default OrlResultsSkeleton;
